//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import PROJECT_ROLES from '@/constants/project-roles'
import SelectSupervisorCollaborator from '@/components/Projects/NewProjectSteps/StepSupervisorCollaborator/SelectSupervisorCollaborator.vue'
import ModalEditUser from '@/components/Projects/users/ModalEditUser.vue'
import ModalDeleteUser from '@/components/Projects/users//ModalDeleteUser.vue'
import ModalErrorUsers from '@/components/Projects/users/ModalErrorUsers.vue'

export default {
  name: 'ProjectSupervisorCollaboratorList',
  components: {
    SelectSupervisorCollaborator,
    ModalEditUser,
    ModalDeleteUser,
    ModalErrorUsers,
  },
  filters: {
    fullNames(user) {
      return `${user?.names} ${user?.lastnames}`
    },
    showEmail(user) {
      return user?.email
    },
    showShortEmail(user) {
      return user?.email?.length > 20
        ? `${user?.email?.substring(0, 20)}...`
        : user?.email
    },
  },
  props: {
    users: {
      default: () => [],
      type: Array,
    },
    total: {
      default: 0,
      type: Number,
    },
    perPage: {
      default: 10,
      type: Number,
    },
    filter: {
      default: '',
      type: String,
    },
    filterByType: {
      default: null,
      type: String || null,
    },
  },
  data() {
    return {
      currentPage: 1,
      textModalErrorUsers: '',
      isShowModalEditUsers: false,
      isShowModalDeleteUsers: false,
      isShowModalErrorUsers: false,
      userToEdit: {},
      userToDelete: {},
    }
  },
  computed: {
    ...mapGetters({
      getBaseProject: 'project/getBaseProject',
    }),
    filteredUsers() {
      const searchText = this.filter ? this.filter.trim().toLowerCase() : null
      const selectedType = this.filterByType

      if (!searchText && selectedType === null) {
        return this.users
      }

      return this.users.filter((user) => {
        let matchesSearchText = false
        if (searchText) {
          const name = (user.names || '').toLowerCase()
          const lastname = (user.lastnames || '').toLowerCase()
          const email = (user.email || '').toLowerCase()

          matchesSearchText =
            name.includes(searchText) ||
            lastname.includes(searchText) ||
            email.includes(searchText)
        }

        let matchesSelectedType = false
        if (selectedType !== null) {
          matchesSelectedType =
            user.projectRole && user.projectRole.employee_type === selectedType
        }

        if (searchText && selectedType !== null) {
          return matchesSearchText && matchesSelectedType
        } else if (searchText) {
          return matchesSearchText
        } else if (selectedType !== null) {
          return matchesSelectedType
        }
        return false
      })
    },
    rulesByRole() {
      if (
        this.userToEdit?.projectRole?.employee_type === PROJECT_ROLES.SUPERVISOR
      ) {
        return [
          'names',
          'lastnames',
          'identification_number',
          'email',
          'repeatEmail',
        ]
      }
      return ['names', 'lastnames', 'identification_number']
    },
  },
  methods: {
    isDisableToCollaborator(user) {
      if (user.autogenerated_email) {
        return true
      }

      if (user.projectRole.employee_type === PROJECT_ROLES.SUPERVISOR) {
        return user.project_roles.some(
          (projectRole) =>
            projectRole.employee_type === PROJECT_ROLES.COLLABORATOR &&
            projectRole.project !== this.getBaseProject.id &&
            projectRole.deleted_at === null
        )
      }

      return (
        user.projectRole.employee_type === PROJECT_ROLES.COLLABORATOR &&
        !user.email
      )
    },
    onPageChange(page) {
      this.currentPage = page
      this.$emit('on-page-change', page)
    },
    updateSupervisorCollaborator(selectedOption) {
      this.$emit('updateSupervisorCollaborator', selectedOption)
    },
    toggleModalEditUsers() {
      this.isShowModalEditUsers = !this.isShowModalEditUsers
    },
    toggleModalDeleteUsers() {
      this.isShowModalDeleteUsers = !this.isShowModalDeleteUsers
    },
    toggleModalErrorUsers() {
      this.isShowModalErrorUsers = !this.isShowModalErrorUsers
    },
    editUserAction(user) {
      this.userToEdit = user
      this.isShowModalEditUsers = true
    },
    deleteUserAction(user) {
      this.userToDelete = user
      this.isShowModalDeleteUsers = true
    },
    isUserFromThisProject(user) {
      return user.original_project === this.getBaseProject.id
    },
    async editUserConfirmed(userToEdit) {
      this.$store.commit('loading', true)
      try {
        await this.$repository.user.update(userToEdit.id, userToEdit)
        this.$emit('user-edited')
        this.toggleModalEditUsers()
      } catch (e) {
        if (e.message === 'username.alreadyTaken.') {
          this.textModalErrorUsers = 'el email ya pertenece a otro usuario.'
        }
        this.toggleModalErrorUsers()
        this.$store.commit('loading', false)
      } finally {
        this.$store.commit('loading', false)
      }
    },
    async deleteUserConfirmed(userToDelete) {
      this.$store.commit('loading', true)
      try {
        await this.$repository.projectRoles.delete(userToDelete.projectRole.id)
        if (
          userToDelete.projectRole.employee_type === PROJECT_ROLES.COLLABORATOR
        ) {
          const usersIds = this.users
            .filter(
              (user) =>
                user.id !== userToDelete.id &&
                user.projectRole.employee_type === PROJECT_ROLES.COLLABORATOR
            )
            .map((user) => user.id)
          await this.$repository.project.update(this.getBaseProject.id, {
            users: usersIds,
            total_users: usersIds.length,
          })
          await this.$repository.supervisorAssignments.deleteByUserAndProject(
            userToDelete.id,
            userToDelete.project.id
          )
        }

        if (
          userToDelete.projectRole.employee_type === PROJECT_ROLES.SUPERVISOR
        ) {
          await this.$repository.supervisorAssignments.deleteBySupervisorAndProject(
            userToDelete.id,
            this.getBaseProject.id
          )
        }
        this.$emit('user-deleted')
      } catch (error) {
        this.toggleModalErrorUsers()
        this.textModalErrorUsers = 'No se puedo eliminar al usuario.'
        this.$store.commit('loading', false)
      } finally {
        this.$store.commit('loading', false)
      }
    },
  },
}
